import { render, staticRenderFns } from "./DocumentsTreeExpertActions.vue?vue&type=template&id=1914753f&scoped=true&lang=pug"
import script from "./DocumentsTreeExpertActions.vue?vue&type=script&lang=ts"
export * from "./DocumentsTreeExpertActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1914753f",
  null
  
)

/* custom blocks */
import block0 from "./DocumentsTreeExpertActions.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FDocuments%2FDocumentsTreeExpertActions.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports